import type { Canvas, CanvasEvents } from "fabric";
import { useEffect } from "react";

type EventCallback<T extends keyof CanvasEvents> = (e: CanvasEvents[T]) => void;

export const useCanvasEventsListener = <T extends keyof CanvasEvents>({
  eventTypes,
  onEvent,
  canvas,
}: {
  eventTypes: T[];
  onEvent: EventCallback<T>;
  canvas?: Canvas;
}) => {
  useEffect(() => {
    if (!canvas) return;

    for (const eventType of eventTypes) {
      canvas.on(eventType, onEvent);
    }

    return () => {
      for (const eventType of eventTypes) {
        canvas.off(eventType, onEvent);
      }
    };
  }, [canvas, eventTypes, onEvent]);
};
